import { type ReactNode } from 'react';

import { useHoveredOfferContext } from '@/app/shared/context/HoveredOfferContext';

import { useCardOfferContext } from '../../../context/selectors';
import { CardChatButtonResponsiveContainer } from '../../CardChatButtonResponsiveContainer';
import { CardContactsButtonMobileContainer } from '../../CardContactsButtonContainer';
import { ContentActionsLayout } from '../components/ContentActionsLayout';

export function ContentActionsContainer(): ReactNode {
  const { hoveredOffer } = useHoveredOfferContext();
  const { id: offerId } = useCardOfferContext();

  return (
    <ContentActionsLayout hovered={hoveredOffer?.id === offerId}>
      <CardContactsButtonMobileContainer />
      <CardChatButtonResponsiveContainer />
    </ContentActionsLayout>
  );
}
